import { siteEnv } from './lib/siteEnv';

/** Denamico's HubSpot account; the tracking code is https://js.hs-scripts.com/<portalId>.js. */
const TRACKING_SRC = (portalId: string) => `https://js.hs-scripts.com/${encodeURIComponent(portalId)}.js`;

/**
 * The one place HubSpot's tracking code could load on the public pages. Off by default: no analytics or tracking
 * scripts ship until there is a consent decision. To turn it on later:
 *   1. build with PAIRING_HS_TRACKING=on and PAIRING_CONTACT_PORTAL_ID set;
 *   2. add https://js.hs-scripts.com and HubSpot's other script and connect hosts to the site CSP in serve.mjs;
 *   3. gate this call on the visitor's consent (a banner), not just the flag.
 * With it on, the contact form sends the hubspotutk cookie with each submission.
 */
export function loadHubSpotTracking(env = siteEnv, doc: Document | undefined = typeof document === 'undefined' ? undefined : document): boolean {
  if (!env.hsTracking || !env.contactPortalId || !doc) return false;
  if (doc.getElementById('hs-script-loader')) return true;
  const script = doc.createElement('script');
  script.id = 'hs-script-loader';
  script.async = true;
  script.defer = true;
  script.src = TRACKING_SRC(env.contactPortalId);
  doc.body.appendChild(script);
  return true;
}
